import { ApplicationRootState } from 'store/types';

const selectBackOfficeUser = (state: ApplicationRootState) =>
  state.backOfficeUser;

export default selectBackOfficeUser;
